import { useState, useEffect } from 'react'

// Define breakpoints (customize as needed)
const MOBILE_BREAKPOINT = 768 // Anything below this value is considered mobile

type Breakpoint = 'mobile' | 'desktop'

// Hook to detect if the user is on a mobile or desktop device
export const useBreakPoint = (): Breakpoint => {
  const [device, setDevice] = useState<Breakpoint>(
    window.innerWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop'
  )

  const handleResize = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      setDevice('mobile')
    } else {
      setDevice('desktop')
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return device
}
